"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = invariant;

function invariant(condition, message) {
  var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')

  if (!booleanCondition) {
    throw new Error(message != null ? message : 'Unexpected invariant triggered.');
  }
}



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/graphql/jsutils/invariant.js
// module id = 17Zf
// module chunks = 0